// Акцентный цвет приходит от бизнеса и подставляется в CSS-переменную, а
// запасной вариант — прежний бирюзовый Chakra, чтобы форма без настройки
// выглядела как раньше.
export const ACCENT = 'var(--sagi-accent, #2C7A7B)'

// Chakra красит кнопки colorScheme'ом и произвольный hex не принимает,
// поэтому акцент проставляется стилями поверх схемы.
export const accentOutline = {
  color: ACCENT,
  borderColor: ACCENT,
  _hover: { bg: 'transparent', opacity: 0.85 },
  _active: { bg: 'transparent', opacity: 0.7 },
}
